import { render, staticRenderFns } from "./Awnsers.vue?vue&type=template&id=7d110ede&lang=pug"
import script from "./Awnsers.vue?vue&type=script&lang=js"
export * from "./Awnsers.vue?vue&type=script&lang=js"
import style0 from "./Awnsers.vue?vue&type=style&index=0&id=7d110ede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports